(function() {
  var SVG_PATH = 'M10 1l2.4 7.4H20l-6.2 4.5 2.4 7.4L10 16l-6.2 4.3 2.4-7.4L0 8.4h7.6z';

  function makeStar() {
    var span = document.createElement('span');
    span.className = 'noxor-comp__star';
    span.innerHTML =
      '<svg viewBox="0 0 20 20">' +
        '<path class="star-empty" d="' + SVG_PATH + '"/>' +
        '<path class="star-full" d="' + SVG_PATH + '"/>' +
      '</svg>';
    return span;
  }

  function buildStars(el) {
    var rating = parseInt(el.dataset.rating) || 5;
    for (var i = 0; i < 5; i++) {
      var star = makeStar();
      if (i < rating) star.dataset.shouldFill = '1';
      el.appendChild(star);
    }
  }

  function init() {
    document.querySelectorAll('.noxor-comp__stars').forEach(buildStars);

    var rows = document.querySelectorAll('.noxor-comp__row--hidden');
    if (!rows.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(rows).indexOf(entry.target);
        setTimeout(function() {
          entry.target.classList.remove('noxor-comp__row--hidden');
          entry.target.classList.add('noxor-comp__row--visible');
          entry.target.querySelectorAll('.noxor-comp__star[data-should-fill="1"]')
            .forEach(function(star, si) {
              setTimeout(function() {
                star.classList.add('filled');
              }, si * 100);
            });
        }, index * 150);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    rows.forEach(function(row) { observer.observe(row); });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
